/**
 * Session detail tab (history).
 */
import * as React from 'react';
import { Clock } from 'lucide-react';
import { DetailsCard } from '@/components/common/DetailsCard';
import type { SessionWithParticipants } from '@/types/inperson/session.types';

/** Props for {@link SessionHistoryTab}. */
interface SessionHistoryTabProps {
  session: SessionWithParticipants;
}

/** Session detail tab (history). */
export const SessionHistoryTab: React.FC<SessionHistoryTabProps> = ({ session }) => (
  <div className="details-view-grid">
    <DetailsCard icon={Clock} title="Historique" colorName="color-1" colSpan="full">
      <div className="space-y-2">
        {session.createdAt && (
          <p className="text-sm text-muted-foreground">
            Créé le {new Date(session.createdAt).toLocaleDateString('fr-FR')}
          </p>
        )}
        {session.updatedAt && (
          <p className="text-sm text-muted-foreground">
            Modifié le {new Date(session.updatedAt).toLocaleDateString('fr-FR')}
          </p>
        )}
      </div>
    </DetailsCard>
  </div>
);
